import { gql } from "@apollo/client";

export const GET_DEVICE_REGISTERS = gql`
  query DeviceRegisters($domain: String!, $limit: Int!, $offset: Int!) {
    device {
      registers(domain: $domain, limit: $limit, offset: $offset) {
        device_register_id
        fk_lan_controllers
        cpu_id
      }
    }
  }
`

export interface DeviceRegister  {
  device_register_id: number;
  fk_lan_controllers: number;
  cpu_id: string;
}

export interface DeviceRegistersResponse {
  device: {
    registers: DeviceRegister[]
  } 
}

export interface DeviceRegisterArgs {
  domain: string;
  limit: number;
  offset: number;
}